import { useMemo, useState } from 'react';
import { AddressHttpService } from '../services';
import { useAppContext } from 'app/context/AppContextProvider';

const useAddress = () => {
  const { dns } = useAppContext();
  const [isFetchingPostalCode, setIsFetchingPostalCode] = useState(false);
  const [isFetchingCities, setIsFetchingCities] = useState(false);

  const isLocalOrSandboxEnv = useMemo(
    () =>
      [
        'localhost:3000',
        'localhost:3002',
        'd3vrw2742r7c9x.cloudfront.net',
        'portal.dev.credit.celcoin.com.br',
      ].includes(dns),
    [dns],
  );

  const fetchCities = async (stateCode: string) => {
    try {
      setIsFetchingCities(true);

      const addressHttpService = new AddressHttpService(isLocalOrSandboxEnv);
      addressHttpService.setHeader({
        handled: true,
      });
      const res = await addressHttpService.getCities(stateCode);

      return res;
    } catch (error) {
      console.error('Erro ao buscar cidades', error);
    } finally {
      setIsFetchingCities(false);
    }
  };

  const fetchAddressByPostalCode = async (postalCode: string) => {
    try {
      setIsFetchingPostalCode(true);

      const addressHttpService = new AddressHttpService(isLocalOrSandboxEnv);
      addressHttpService.setHeader({
        handled: true,
      });
      const res = await addressHttpService.getAddressByPostalCode(postalCode);

      return res;
    } catch (e) {
      console.error('Erro ao buscar endereço pelo cep', e);
    } finally {
      setIsFetchingPostalCode(false);
    }
  };

  return {
    isFetchingCities,
    fetchCities,
    isFetchingPostalCode,
    fetchAddressByPostalCode,
  };
};

export default useAddress;
